import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Survey from "@/pages/Survey";
import Admin from "@/pages/Admin";
import Responses from "@/pages/Responses";
import Orchestration from "@/pages/Orchestration";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center text-[var(--burgundy)]">
      <Loader2 className="w-7 h-7 animate-spin" />
    </div>
  );
}

function Protected({ children, adminOnly, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/IAMquestionnaire" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/IAMquestionnaire" replace />;
  return children;
}

function LoginRoute() {
  const { user, ready } = useAuth();
  if (!ready) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/IAMquestionnaire" element={<Protected><Survey /></Protected>} />
          <Route path="/responses" element={<Protected><Responses /></Protected>} />
          <Route path="/orchestration" element={<Protected roles={["admin", "operator"]}><Orchestration /></Protected>} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
